export const getBuilderTypePage = () => {
  let type = 'project'
  try {
    if (String(location.pathname).startsWith('/fttitanfiles/')) {
      type = 'titanfiles'
    }
  } catch (err) {}
  return type
}
